import { Button, Select } from '@attentive-platform/stem-ui';

const BearerTableRow = ({ row, index, targetOptions, isDirty, isSaving, isSaved, onUpdateTargets, onSave }) => (
  <tr className='border-t border-gray-100'>
    <td className='p-3'>{row.user_email || '—'}</td>
    <td className='p-3'>
      <Select
        multiple
        color='primary'
        variant='std-outlined'
        items={targetOptions}
        value={row.targetIds}
        placeholder='Select integrations'
        onChange={values => onUpdateTargets(index, values)}
        onClose={() => {}}
      />
    </td>
    <td className='p-3'>
      <Button
        size='small'
        color='primary'
        variant='outlined'
        disabled={!isDirty && !isSaved}
        loading={isSaving}
        onClick={() => onSave(index)}>
        {isSaved && !isDirty ? '✓ Saved' : 'Save'}
      </Button>
    </td>
  </tr>
);

export default BearerTableRow;
